//наша middleware, смотрит что если передали promise то мы генерируем action-ы и обработкой промиса

export default store => next => action => {
	if(action.type === 'PROMISE') {
		const [START_ACTION, FINISH_ACTION, ERROR_ACTION] = action.actions;
	
		store.dispatch({type: START_ACTION});
		action.promise.then(function(res) {
			store.dispatch({
				type: FINISH_ACTION,
				data: res.data
			});
		}).catch(function(error) {
			store.dispatch({
				type: ERROR_ACTION,
				data: error
			});
		});
	} else {
		return next(action);
	}
	
};


// WEBPACK FOOTER //
// ./src/middleware/api.js